import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerSecciones=async(consultanteid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/campos/secciones/`+consultanteid;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const editarUsuarioConsultante=async(consultanteid,respuestas,camposActualizadosCompletos,token)=>{

    const url=config.REACT_APP_WEBAPI_URL+`/consultantes`;
    const resp=await fetch(url,
        {
            method:"PATCH",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
                    
                
            },
            body:JSON.stringify(
                {
                    ConsultanteId:consultanteid,
                    Respuestas:respuestas,
                    CamposCompletosPorActualizar: camposActualizadosCompletos
                })
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const ingresarUsuarioConsultante=async(usuario,token)=>{
   
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(usuario)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};

export const obtenerUsuariosConsultantesPorFiltro=async(filtro,token)=>{
    
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes`;
    const resp=await fetch(
        url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        });
    
    validarSesion(resp.status)
    
    const {data}=await resp.json();
    if(filtro!='' && filtro!=undefined){
        
        const dataFiltro=data.filter(item=>{
            if( item.Correo?.toUpperCase().includes(filtro.toUpperCase()) ||
                item.NombreSocial?.toUpperCase().includes(filtro.toUpperCase()) ||
                item.NombreCompleto?.toUpperCase().includes(filtro.toUpperCase())
            )
            {
                return item;
        }});
        console.warn(dataFiltro);
        return dataFiltro;
    }
    console.warn(data);
    return data;

};
export const obtenerUsuarioConsultante=async(usuario,token)=>{
    if(usuario=='')
    {
        return {};
    }
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/`+usuario;
    const resp=await fetch(url,
    {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
    });
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;

};


export const obtenerArchivosSubidosFicha=async(usuario,token)=>{
    if(usuario=='')
    {
        return {};
    }
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/archivos/`+usuario.Id;
    const resp=await fetch(url,
    {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
    });
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;

};

export const subirArchivoFicha=async(consultante,archivo,descripcion,token)=>{
    const formData = new FormData();
    formData.append('Archivo', archivo);
    formData.append('ConsultanteId', consultante);
    formData.append('Descripcion', descripcion);
    formData.append('Nombre', archivo.name);
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/archivo`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                'x-token':token
            },
            body:formData
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const eliminarArchivoFicha=async(consultante,archivoid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/archivos/eliminar`;
    const resp=await fetch(url,
        {
            method:"PATCH",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
                    
                
            },
            body:JSON.stringify({ConsultanteId:consultante,Id:archivoid})
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;

};
export const obtenerArchivoFicha=async(usuario,archivoid,token)=>{
    if(usuario=='')
    {
        return {};
    }
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/archivos/`+usuario.Id+`/`+archivoid;
    const resp=await fetch(url,
    {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
    });
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
};
export const actualizarUsuarioConsultante=async(usuario,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(usuario)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};
export const obtenerCamposPorConsultante=async(consultanteid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/campos/`+consultanteid;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerSesionesPorConsultante=async(consultanteid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/sesiones/`+consultanteid;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerUsuariosTerapeutasOcupacionales=async(token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/usuarios/to`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    //data.FechaNacimiento=data.FechaNacimiento.substring(0,10);
    return data;

};
export const obtenerUsuariosPsicologas=async(token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/usuarios/psicologas`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    //data.FechaNacimiento=data.FechaNacimiento.substring(0,10);
    return data;

};
export const obtenerUsuariosOtros=async(token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/usuarios/otros`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    //data.FechaNacimiento=data.FechaNacimiento.substring(0,10);
    return data;

};
export const ingresarSesion=async(sesion,token)=>{
   
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/sesiones/`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(sesion)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
    
};
export const editarSesion=async(sesion,token)=>{
   
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/sesion/`;
    const resp=await fetch(url,
        {
            method:"PUT",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(sesion)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
    
};
export const obtenerSesionPorSesionId=async(sesionId,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/sesion/`+sesionId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
};
export const deshabilitarFichaConsultante=async(consultante,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/`;
    const resp=await fetch(url,
        {
            method:"DELETE",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify({ConsultanteId:consultante})
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};
export const eliminarSesion=async(data,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/sesion/`;
    const resp=await fetch(url,
        {
            method:"DELETE",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify(data)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};

export const obtenerParticipacionesGrupalesPorConsultante=async(consultanteid,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/participaciongrupal/`+consultanteid;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const eliminarParticipacionGrupal=async(data,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/participaciongrupal/`;
    const resp=await fetch(url,
        {
            method:"DELETE",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify(data)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};
export const ingresarParticipacionGrupal=async(participacionGrupal,token)=>{
   
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/participaciongrupal/`;
    const resp=await fetch(url,
        {
            method:"POST",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(participacionGrupal)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
    
};
//todo
export const editarParticipacionGrupal=async(participacion,token)=>{
   
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/participaciongrupal/`;
    const resp=await fetch(url,
        {
            method:"PUT",
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            body:JSON.stringify(participacion)
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
    
};
//todo
export const obtenerParticipacionGrupalPorId=async(participacionId,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/consultantes/participacion/`+participacionId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
};
export const habilitarFichaConsultante=async(consultante,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/consultantehistorico`;
    const resp=await fetch(url,
        {
            method:"PATCH",
            headers:{
                'Content-Type':'application/json',        
                'x-token':token
            },
            body:JSON.stringify({ConsultanteId:consultante})
        }
    );
    validarSesion(resp.status)
    const respuesta=await resp.json();
    return respuesta;
};


export const obtenerUsuariosConsultantesHistoricoPorFiltro=async(filtro,token)=>{
    
    const url=config.REACT_APP_WEBAPI_URL+`/consultantehistorico`;
    const resp=await fetch(
        url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        });
    
    validarSesion(resp.status)
    
    const {data}=await resp.json();
    if(filtro!='' && filtro!=undefined){
        
        const dataFiltro=data.filter(item=>{
            if( item.Correo?.toUpperCase().includes(filtro.toUpperCase()) ||
                item.NombreSocial?.toUpperCase().includes(filtro.toUpperCase()) ||
                item.NombreCompleto?.toUpperCase().includes(filtro.toUpperCase())
            )
            {
                return item;
        }});
        console.warn(dataFiltro);
        return dataFiltro;
    }
    console.warn(data);
    return data;

};